module.exports = __webpack_public_path__ + "static/media/RESTORE-4th-of-July.ee174c35.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/RESTORE-4th-of-July.png
// module id = 689
// module chunks = 0